import {Box, useTheme} from '@mui/material';
import {blockExplorers} from '../../constants/block-explorers';
import {AddressButton} from './AddressButton';

export interface TransactionHashProps {
  chainId: number;
  tx: string;
}

export const ViewTransactionButton = ({
  chainId,
  tx: transactionHash,
}: TransactionHashProps) => {
  const theme = useTheme();

  return (
    <AddressButton
      target="_blank"
      startIcon={
        <Box
          component="img"
          src={'/app/icons/eth-scan.png'}
          height="1.25rem"
          width="1.25rem"
        />
      }
      sx={{
        bgcolor: theme.palette.background.default,
        '&:hover': {bgcolor: theme.palette.background.default},
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: 1.2,
        px: 1.5,
        py: 1,
      }}
      href={`${blockExplorers[chainId]}tx/${transactionHash}`}
      address={transactionHash}
    />
  );
};
